<div class="rate-guest-form">
  <div class="info-section">
    <div class="field-row">
      <label>Property ID:</label>
      <span>{{shortTermRentalId}}</span>
    </div>
    @if (reservationId) {
      <div class="field-row">
        <label>Reservation ID:</label>
        <span>{{reservationId}}</span>
      </div>
    }
    @if (guestName) {
      <div class="field-row">
        <label>Guest:</label>
        <span>{{guestName}}</span>
      </div>
    }
    @if (isEdit) {
      <div class="field-row">
        <label></label>
        <span style="color: #2196F3; font-style: italic;">Editing existing guest rating</span>
      </div>
    }
  </div>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <!-- Overall Rating -->
    <div class="field-row" style="margin-top: 15px;">
      <label>Overall Rating: <span style="color: red;">*</span></label>
      <p-rating formControlName="overallRating" [stars]="5" [cancel]="true"></p-rating>
    </div>

    <!-- Overall Rating Description -->
    <div class="field-row">
      <label>Overall Description:</label>
      <textarea pInputTextarea formControlName="overallRatingDesc" rows="3"
        style="width: 100%; max-width: 400px;"
      placeholder="Describe the overall guest experience..."></textarea>
    </div>

    <!-- Cleanliness Rating -->
    <div class="field-row">
      <label>Cleanliness:</label>
      <p-rating formControlName="cleanlinessRating" [stars]="5" [cancel]="true"></p-rating>
    </div>

    <!-- House Rules Rating -->
    <div class="field-row">
      <label>House Rules:</label>
      <p-rating formControlName="houseRulesRating" [stars]="5" [cancel]="true"></p-rating>
    </div>

    <!-- Communication Rating -->
    <div class="field-row">
      <label>Communication:</label>
      <p-rating formControlName="communicationRating" [stars]="5" [cancel]="true"></p-rating>
    </div>

    <!-- Private Guest Message -->
    <div class="field-row">
      <label>Private Message:</label>
      <textarea pInputTextarea formControlName="privateGuestMsg" rows="3"
        style="width: 100%; max-width: 400px;"
      placeholder="Private message to the guest..."></textarea>
    </div>

    <!-- Recommend Guest -->
    <div class="field-row">
      <label>Recommend Guest:</label>
      <p-checkbox formControlName="recommendGuest" [binary]="true"></p-checkbox>
    </div>

    <!-- Actions -->
    <div class="actions" style="margin-top: 20px;">
      <button pButton pRipple type="submit" class="p-button-success"
        [label]="isEdit ? 'Update Rating' : 'Submit Rating'"
      [loading]="submitting" style="margin-right: 10px;"></button>
      <button pButton pRipple type="button" class="p-button-secondary" label="Cancel"
      (click)="cancel()"></button>
    </div>
  </form>
</div>
